import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { SystemSettings } from '@jobos/shared';
import { useToast } from '@/hooks/use-toast';

export const settingsKeys = {
  all: ['settings'] as const,
  system: () => [...settingsKeys.all, 'system'] as const,
};

export function useSystemSettings() {
  return useQuery({
    queryKey: settingsKeys.system(),
    queryFn: async () => {
      return apiClient.get<SystemSettings>('/settings');
    },
  });
}

export function useUpdateSystemSettings() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (data: Partial<SystemSettings>) => {
      return apiClient.put<SystemSettings>('/settings', data);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(settingsKeys.system(), data);
      toast({
        title: 'Settings saved',
        description: 'Default rates have been updated.',
      });
    },
    onError: (error: Error) => {
      toast({
        title: 'Error',
        description: error.message || 'Failed to save settings.',
        variant: 'destructive',
      });
    },
  });
}
